import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractInputComponent } from '@shared/form-elements/input/abstract-input/abstract-input.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ControlToKeyNamePipe } from '@shared/form-elements/pipes/control-to-key-name.pipe';
import { ValidationErrorMessagePipe } from '@shared/form-elements/pipes/validation-error-message.pipe';
import { FirstKeyPipe } from '@shared/form-elements/pipes/first-key.pipe';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClass, NgIf } from '@angular/common';
import { AutofocusDirective } from '@shared/autofocus/autofocus.directive';

@UntilDestroy()
@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        SvgIconComponent,
        TranslateModule,
        TranslateSafePipe,
        FirstKeyPipe,
        ValidationErrorMessagePipe,
        ControlToKeyNamePipe,
        AutofocusDirective
    ]
})
export class InputComponent extends AbstractInputComponent implements OnInit {
    public focused = false;
    public showClearButton = false;

    @ViewChild('inputRef') public inputRef: ElementRef<HTMLInputElement>;

    @Input()
    type: string = 'text';
    @Input()
    autocomplete: string = '';

    @Input()
    autofocus: boolean = false;

    @Input()
    helpText?: string;

    ngOnInit(): void {
        if (this.clearButton) {
            this.control.valueChanges
                .pipe(untilDestroyed(this))
                .subscribe(value => (this.showClearButton = !!value.length));
        }
    }

    public onClearField(): void {
        this.control.patchValue('');
    }

    public get showError(): boolean {
        return !!(this.control.touched && this.control.errors);
    }

    public get showValid(): boolean {
        return !this.showError && this.focused && this.control.touched;
    }

    public onFocus(): void {
        this.focused = true;
    }

    public onBlur(): void {
        this.focused = false;
        this.inputBlur.emit();
    }
}
